import useLoading from '../../control/loading/useLoading'
import useCallApi from '../../utilities/axios'
import { GetProjectCertificateResponse, ServiceResult } from './types/responseWebServiceTypes'
import { getCertificateByProjectId } from './webServiceURL'

const useCeritificates = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const getCertificatesByProjectId = async (projecId: number) => {
        try {
            loadingHook.loadingOpen()
            const apiUrl = `${getCertificateByProjectId}/${projecId}`
            const { data } = await callApi.axiosGet<ServiceResult<GetProjectCertificateResponse[]>>({
                url: apiUrl,
            })
            return data
        } catch (error) {
            /** Must Not Empty */
        } finally {
            loadingHook.loadingClose()
        }
    }

    return {
        getCertificatesByProjectId,
    }
}

export default useCeritificates
